import React from "react";
import TableData from "../../../../../../../../_components/TableData";
import Modal from "../../../../../../../../_components/Modal";
import Button from "../../../../../../../../_components/Button";
import { _Input } from "../../../../../../../../_components/Input";
import { CreateNFeContext } from "../../../../Context";
import Currency from "react-currency-formatter";
import { formatDate } from "../../../../../../../../utils";
import IconButton from "../../../../../../../../_components/IconButton";

export default (props) => {
  const [data, setData] = React.useState([]);
  const context = React.useContext(CreateNFeContext);

  function removePayment(payment) {
    context.handlers.setNFePayments(
      context.nfe.payments.filter((pay, idx) => idx !== payment.idx)
    );
  }

  function handleListPayments() {
    if (context.nfe.payments) {
      setData(
        context.nfe.payments.map((pay, idx) => {
          let dueDue = pay.due_date ? (
            <React.Fragment>
              {formatDate(pay.due_date)}
              <UpdateDueDate pay={pay} />
            </React.Fragment>
          ) : (
            ""
          );
          pay.idx = idx;
          return {
            name: pay.name,
            idx,
            value: (
              <React.Fragment>
                <Currency quantity={pay.value} symbol="R$ " currency="brl" />
                <UpdatePrice pay={pay} />
              </React.Fragment>
            ),
            formatedDueDate: dueDue,
            actions: (
              <div>
                <IconButton
                  onClick={() => {
                    removePayment(pay);
                  }}
                  className="text-danger"
                  icon="trash-alt"
                />
              </div>
            ),
          };
        })
      );
    }
  }
  React.useEffect(handleListPayments, [
    context.nfe.total_paid,
    context.nfe.payments,
    context.nfe,
  ]);

  if (data.length > 0) {
    return (
      <TableData
        tHead={["Forma de pagamento", "Valor pago", "Vencimento", "Ações"]}
        data={data}
        tBodyKeys={["name", "value", "formatedDueDate", "actions"]}
      />
    );
  } else {
    return <span />;
  }
};

function UpdateDueDate(props) {
  const [show, setShow] = React.useState(false);
  const [newDate, setDate] = React.useState(null);
  const context = React.useContext(CreateNFeContext);

  function onHide() {
    setShow(false);
    setDate(null);
  }
  
  function onUpdate() {
    if (!newDate) {
      onHide();
      return;
    }
    let [year, month, day] = newDate.split("-");
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    
    const newPayments = context.nfe.payments.map((p, idx) => {
      if (idx === props.pay.idx) {
        return { ...p, due_date: date };
      }
      return p;
    });

    context.handlers.setNFePayments(newPayments);
    onHide();
  }

  React.useEffect(() => {
    if (show && props.pay.due_date) {
      const dateObj = new Date(props.pay.due_date);
      const formattedDate = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`;
      setDate(formattedDate);
    }
  }, [show, props.pay.due_date]);

  return (
    <React.Fragment>
      <IconButton onClick={() => setShow(true)} icon="edit" />
      <Modal show={show} title="Atualizar Vencimento" onHide={onHide}>
        <div className="d-flex justify-content-center">
          <_Input
            onChange={(e) => {
              setDate(e.value);
            }}
            type="date"
            value={newDate}
          />
        </div>
        <div className="d-flex justify-content-center">
          <Button onClick={onUpdate}>Atualizar</Button>
        </div>
      </Modal>
    </React.Fragment>
  );
}


function UpdatePrice(props) {
  const [show, setShow] = React.useState(false);
  const [value, setValue] = React.useState(0);
  const context = React.useContext(CreateNFeContext);

  function onHide() {
    setShow(false);
    setValue(0);
  }
  
  function onUpdate() {
    if (!value) {
      onHide();
      return;
    }
    
    const newPayments = context.nfe.payments.map((p, idx) => {
      if (idx === props.pay.idx) {
        return { ...p, value: value };
      }
      return p;
    });

    context.handlers.setNFePayments(newPayments);
    context.handlers.updateTotalNFe();
    onHide();
  }

  React.useEffect(() => {
    if (show) {
      setValue(props.pay.value);
    }
  }, [show, props.pay.value]);

  return (
    <React.Fragment>
      <IconButton onClick={() => setShow(true)} icon="edit" />
      <Modal show={show} title="Atualizar Valor" onHide={onHide}>
        <div className="d-flex justify-content-center">
          <_Input
            onChange={(e) => {
              setValue(e.value);
            }}
            type="currency"
            value={value}
          />
        </div>
        <div className="d-flex justify-content-center">
          <Button onClick={onUpdate}>Atualizar</Button>
        </div>
      </Modal>
    </React.Fragment>
  );
}




// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/Payments/components/PaymentsTable/index.jsx